import React, { useState } from "react";
import Cropper, { Area, Point } from "react-easy-crop";
import { RotateCw, ZoomIn, ZoomOut } from "lucide-react";
import { Slider } from "@/components/ui/slider";

interface ImageCropperProps {
  image: string;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  aspect?: number;
}

const ImageCropper: React.FC<ImageCropperProps> = ({ image, onCropComplete, aspect = 1 }) => {
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  const onCropChange = (crop: Point) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom: number) => {
    setZoom(zoom);
  };

  return (
    <div className="flex size-full flex-col">
      <div className="relative h-[300px] w-full overflow-hidden rounded-md border border-border bg-muted">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          rotation={rotation}
          aspect={aspect}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onRotationChange={setRotation}
          onCropComplete={onCropComplete}
        />
      </div>

      <div className="space-y-4 pt-4">
        <div>
          <p className="eyebrow mb-2 text-muted-foreground">Zoom</p>
          <div className="flex items-center gap-3 text-muted-foreground">
            <ZoomOut className="size-4 shrink-0" aria-hidden />
            <Slider
              aria-label="Zoom"
              value={[zoom]}
              min={1}
              max={3}
              step={0.1}
              onValueChange={(v) => setZoom(v[0])}
            />
            <ZoomIn className="size-4 shrink-0" aria-hidden />
          </div>
        </div>

        <div>
          <p className="eyebrow mb-2 text-muted-foreground">Rotation</p>
          <div className="flex items-center gap-3 text-muted-foreground">
            <RotateCw className="size-4 shrink-0" aria-hidden />
            <Slider
              aria-label="Rotation"
              value={[rotation]}
              min={0}
              max={360}
              step={1}
              onValueChange={(v) => setRotation(v[0])}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;
